import AvatarUploader from './AvatarUploader';
export default AvatarUploader;



// WEBPACK FOOTER //
// ./src/components/Profile/AvatarUploader/index.js